module.exports = __webpack_public_path__ + "img/logo_violet.d7a7ed56.png";